import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';
import arrayToIndexedObject from 'Common/Utils/arrayToIndexedObject';
import { buildPagingQuery, getResource, isSuccessful, processError } from 'Common/Utils/apiHelpers';

const baseUrl = '/api/v2';

async function deleteAmendment(ids, errorCallback) {
    const url = `${baseUrl}/release/amendContract`;
    try {
        const { status, data } = await axios.delete(url, { data: { ids } });
        if (isSuccessful(status)) {
            return true;
        }

        const errorMessage = apiErrorMsg(status, data);
        return errorCallback(errorMessage);
    } catch (err) {
        return processError(err, errorCallback);
    }
}

async function saveAmendment(amendment, errorCallback) {
    const url = `${baseUrl}/release/amendContract`;
    try {
        const { status, data } = await axios.put(url, { amendContractModel: amendment });
        if (isSuccessful(status)) {
            return true;
        }

        const errorMessage = apiErrorMsg(status, data);
        return errorCallback(errorMessage);
    } catch (err) {
        return processError(err, errorCallback);
    }
}

async function fetchAmendments(year, types, query, errorCallback) {
	const typesEncoded = encodeURIComponent(JSON.stringify(arrayToIndexedObject(Array.isArray(types) ? types : [types])));
	const queryEncoded = encodeURIComponent(JSON.stringify(query));
	const url = `${baseUrl}/release/amendContract/${year}/${typesEncoded}?pagination=${queryEncoded}`;

    return getResource(url, errorCallback);
}

async function fetchAmendmentDetail(year, markingTeamId, type, query, errorCallback) {
    const queryEncoded = encodeURIComponent(JSON.stringify(query));
    const url = `${baseUrl}/release/amendContract/${year}/details/${markingTeamId}?pagination=${queryEncoded}&appointmentType=${type}`;

    return getResource(url, errorCallback);
}

async function fetchReasons(grouping, type, errorCallback) {
	const groupingEncoded = encodeURIComponent(grouping);
    const url = `${baseUrl}/release/amendContract/amendmentreasons/${groupingEncoded}/${type}`;

    return getResource(url, errorCallback, 'questions');
}

async function fetchTypes(year, grouping, errorCallback) {
	const groupingEncoded = encodeURIComponent(grouping);
	const url = `${baseUrl}/appointments/types/${year}/${groupingEncoded}?showDescription=true`;

    return getResource(url, errorCallback);
}

export { buildPagingQuery, deleteAmendment, saveAmendment, fetchAmendments, fetchAmendmentDetail, fetchReasons, fetchTypes };
